<template>
    <div>
        <vs-row vs-w="12">
            <vs-col vs-w="5" vs-sm="12" class="p-2">
                <vx-card :title="$t('Data')" class="mb-base" id="page-user-view">
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ client.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("VATNumber")}}</td>
                            <td>{{ client.vat }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Address")}}</td>
                            <td>{{ client.address }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Country")}}</td>
                            <td>{{ client.country }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("ContractHours")}}</td>
                            <td>{{ client.service_hours }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Email")}}</td>
                            <td>{{ client.contact_mail }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("PhoneNumber")}}</td>
                            <td>{{ client.contact_phone }}</td>
                        </tr>
                        <tr v-if="this.$refs.contactsTable !== undefined">
                            <td class="font-semibold">{{$t("PrimaryContact")}}</td>
                            <td v-if="this.$refs.contactsTable.contactMap[client.primary_contact_id] !== undefined">{{ this.$refs.contactsTable.contactMap[client.primary_contact_id].name + " " + this.$refs.contactsTable.contactMap[client.primary_contact_id].l_name}}</td>
                        </tr>

                        <tr>
                            <td class="font-semibold">
                                <p style="float:left;">
                                    {{$t("Tags")}}
                                </p>
                                <div v-if="!editTags" style="float: left" class="ml-6">
                                    <vs-button v-if="$checkPermission(303)" size="small" color="success" icon-pack="feather" icon="icon-tag" type="border" @click="editTags = true" />
                                </div>
                            </td>
                            <td>
                                <div v-if="editTags">
                                    <v-select class="selectStyle" multiple style="width: 100%" :options="selectableTags" label="name" v-model="selectedTags">
                                        <template slot="option" slot-scope="option">
                                            <div style="display: flex">
                                                <vs-chip :color="option.color" style="margin: auto">
                                                    <p v-bind:style="{color: option.text_color}"><b>{{option.name}}</b></p>
                                                </vs-chip>
                                            </div>
                                        </template>
                                    </v-select>
                                    <vs-button v-if="$checkPermission(303)" class="mt-3" color="success" icon-pack="feather" icon="icon-edit" type="border" @click="saveTags" >{{$t("SaveTags")}}</vs-button>
                                </div>
                                <div v-else>

                                    <vs-chip class="mr-3" :color="item.color" :key="index" v-for="(item,index) in this.client.tags">
                                        <p v-bind:style="{color: item.text_color}"><b>{{item.name}}</b></p>
                                    </vs-chip>

                                </div>
                            </td>


                        </tr>

                    </table>

                    <vs-button v-if="$checkPermission(303)" class="mt-3" color="warning" icon-pack="feather" icon="icon-edit" type="border" @click="editClientPrompt = true" >{{$t("Edit")}}</vs-button>

                </vx-card>
            </vs-col>
            <vs-col vs-w="7" vs-sm="12" class="p-2">
                <client-contacts-table ref="contactsTable" :client-id="Number(this.$route.params.id)"></client-contacts-table>
            </vs-col>
        </vs-row>

        <vs-row vs-w="12">
            <vs-col vs-w="12">
                <client-branch-offices-table ref="branchOfficesTable" :client-id="Number(this.$route.params.id)"></client-branch-offices-table>
            </vs-col>
        </vs-row>

        <vs-popup :title="$t('Edit')" :active.sync="editClientPrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="editClientData['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Address")}}</p>
                <vs-input v-model="editClientData['address']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Country")}}</p>
                <vs-input v-model="editClientData['country']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Email")}}</p>
                <vs-input v-model="editClientData['contact_mail']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("PhoneNumber")}}</p>
                <vs-input v-model="editClientData['contact_phone']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("ContractHours")}}</p>
                <vs-input type="number" v-model="editClientData['service_hours']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("PrimaryContact")}}</p>
                <vs-select v-if="this.$refs.contactsTable !== undefined" autocomplete class="selectExample w-full" v-model="editClientData['primary_contact_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name + ' ' + item.l_name" v-for="(item,index) in this.$refs.contactsTable.contactMap" />
                </vs-select>

                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editClient">{{$t("Save")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeClient">{{$t("Delete")}}</vs-button>

            </div>
        </vs-popup>

    </div>
</template>
<script>

    import ClientContactsTable from "./ClientContactsTable";
    import ClientBranchOfficesTable from "./ClientBranchOfficesTable";
    import vSelect from 'vue-select'

    export default {
        components: {
            ClientBranchOfficesTable,
            ClientContactsTable,
            'v-select': vSelect,
        },
        data() {
            return {
                client: {},

                selectedTags: [],

                editTags: false,

                editClientPrompt: false,
                editClientData: {}
            }
        },
        computed: {
          selectableTags() {

              let tags = [];
              for (let key in this.$store.state.tags) {
                  if (this.$store.state.tags.hasOwnProperty(key)){
                      tags.push(this.$store.state.tags[key])
                  }
              }

              return tags;

          }
        },
        methods: {
            updateClient() {
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.client = response.data;
                        thisIns.selectedTags = JSON.parse(JSON.stringify(response.data.tags));
                        thisIns.editClientData = Object.assign({}, response.data)
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            position:'top-right',
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editClient(){

                this.editClientData['service_hours'] = Number(this.editClientData['service_hours']);
                const thisIns = this;
                this.$http.put('/api/v1/client/' + this.$route.params.id, this.editClientData)
                    .then(function () {
                        thisIns.updateClient();
                        thisIns.editClientPrompt = false;
                    }).catch(function (error) {
                    thisIns.editClientPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        position:'top-right',
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            removeClient(){
                const thisIns = this;
                this.$http.delete('/api/v1/client/' + this.$route.params.id)
                    .then(function () {
                        thisIns.editClientPrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/clients')
                        });
                    }).catch(function (error) {
                    thisIns.editClientPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveTags(){
                const thisIns = this;
                this.$http.put('/api/v1/client/' + this.$route.params.id + "/tags", this.selectedTags)
                    .then(function () {
                        thisIns.updateClient();
                        thisIns.editTags = false;
                    }).catch(function (error) {
                    thisIns.editTags = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        position:'top-right',
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updateClient()
        },
        beforeRouteLeave (to, from, next) {
            if(this.editClientPrompt){
                this.editClientPrompt = false;
                next(false)
            }else if(this.$refs.contactsTable.isPromptOpen()){
                this.$refs.contactsTable.closePrompts();
                next(false)
            }else if(this.$refs.branchOfficesTable.isPromptOpen()){
                this.$refs.branchOfficesTable.closePrompts();
                next(false)
            }else{
                next()
            }
        }
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 160px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
